import {Injectable} from '@angular/core';
import {CustomHttp} from "../core/http-custom/http-custom.service";
import {AppConstants} from "../utils/constants";
import {HttpParams} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {Observable, of} from "rxjs";

@Injectable()
export class AuthDetailsService {

  constructor(private _http: CustomHttp) {

  }

  public getAuthDetails() {
    return this._http.get(AppConstants.authDetailsEndpoint);
  }

  public isAuthenticationRequired(): Observable<boolean> {
    return this._http.get(AppConstants.checkAuthenticationStateEndpoint).pipe(
      map(response => false),
      catchError(error => of(true))
    );

  }

  public getAccessControlData(...paths: string[]) : Observable<Map<string, boolean>> {
    let params = new HttpParams();
    paths.forEach(path => {
      params = params.append('path', path)
    });

    return this._http.get(AppConstants.validationEndpoint, null, params).pipe(
      map(response => {
        if(response.data) {
          return new Map<string,boolean>(Object.entries(response.data));
        }
        return null;
      }),
      catchError(error => of(null))
    );

  }

}
